import { render } from "./RenameDocumentModal.vue?vue&type=template&id=c771fc2e&scoped=true"
import script from "./RenameDocumentModal.vue?vue&type=script&lang=js"
export * from "./RenameDocumentModal.vue?vue&type=script&lang=js"

import "./RenameDocumentModal.vue?vue&type=style&index=0&id=c771fc2e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c771fc2e"]])

export default __exports__